import { render, staticRenderFns } from "./CouponActivityList.vue?vue&type=template&id=4a59cb5f"
import script from "./CouponActivityList.vue?vue&type=script&lang=ts"
export * from "./CouponActivityList.vue?vue&type=script&lang=ts"
import style0 from "./CouponActivityList.vue?vue&type=style&index=0&id=4a59cb5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports